import Aboutarea from './Components/Aboutarea'
import Baner from './Components/Baner'
import Featurearea from './Components/Featurearea'
import "./About.css"
import Counter from '../Home/Components/Counter'
import TeamArea from './Components/TeamArea'

const About = () => {
    return (

        <>
            <Baner />
            <Aboutarea />
            <Featurearea />
            <Counter />
            {/* <TeamArea /> */}
        </>
    )
}

export default About